document.addEventListener('DOMContentLoaded', function() {
  const bundleForms = document.querySelectorAll('.bundle-add-to-cart-form');

  bundleForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      const button = form.querySelector('.bundle-add-to-cart-btn');
      const originalText = button.textContent;

      // Update button state
      button.disabled = true;
      button.textContent = 'Ajout en cours...';

      // Prepare form data
      const formData = new FormData(form);

      // Submit via AJAX
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        // Success feedback
        button.textContent = 'Ajouté ✓';
        button.style.backgroundColor = '#28a745';

        // Update cart if cart drawer exists
        if (typeof window.updateCartDrawer === 'function') {
          window.updateCartDrawer();
        }

        // Reset button after 2 seconds
        setTimeout(() => {
          button.disabled = false;
          button.textContent = originalText;
          button.style.backgroundColor = '';
        }, 2000);
      })
      .catch(error => {
        button.textContent = 'Erreur - Réessayer';
        button.style.backgroundColor = '#dc3545';

        // Reset button after 2 seconds
        setTimeout(() => {
          button.disabled = false;
          button.textContent = originalText;
          button.style.backgroundColor = '';
        }, 2000);
      });
    });
  });
}); 